import React, { useState } from "react";
import { Settings, LogOut, Search, Menu, X } from "lucide-react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import SidebarMenu from "./SidebarMenu";

const Sidebar = ({ collapsed, setCollapsed }) => {
  const toggleSidebar = () => setCollapsed(!collapsed);
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = React.useState(() =>
    JSON.parse(localStorage.getItem("user"))
  );

  // sync setiap kali localStorage berubah
  React.useEffect(() => {
    const handleStorage = () => {
      setUser(JSON.parse(localStorage.getItem("user")));
    };

    // event listener kalau localStorage berubah (misalnya setelah login)
    window.addEventListener("storage", handleStorage);

    // juga jalankan sekali di mount
    handleStorage();

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const isMonitoring = location.pathname.startsWith("/monitoring");
  const isAdmin = user?.role === "admin";
  const isAdminProduk = user?.role === "admin-produk";
  const isAdminProyek = user?.role === "admin-proyek";
  const isSupervisor = user?.role === "supervisor";

  const hasLimitedMenu = isAdminProduk || isAdminProyek;

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("No token found");
        localStorage.removeItem("user");
        navigate("/");
        return;
      }

      const response = await fetch("https://adhimaju.com/auth/logout", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      });

      if (response.ok) {
        localStorage.clear();
        navigate("/");
      } else {
        console.error("Logout failed with status:", response.status);
        localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      console.error("Logout error:", error);
      localStorage.clear();
      navigate("/");
    }
  };

  const sidebarStyles = {
    admin: {
      container: "h-screen bg-deep text-white",
      activeItem: "bg-deep-light",
      hoverItem: "hover:bg-deep-light",
      borderColor: "border-deep-light",
      switchButton: "bg-primary hover:bg-primary-dark",
      groupHeader: "text-deep-light",
    },
    monitoring: {
      container: "h-screen bg-white text-gray-700",
      activeItem: "bg-primary-light/20 text-primary",
      hoverItem: "hover:bg-gray-50",
      borderColor: "border-gray-100",
      switchButton: "bg-deep hover:bg-deep-light",
      groupHeader: "text-gray-500",
    },
  };

  const styles = isMonitoring ? sidebarStyles.monitoring : sidebarStyles.admin;

  return (
    <div
      className={`${styles.container} flex flex-col ${
        collapsed ? "w-16" : "w-64"
      } fixed top-0 left-0 ${
        isMonitoring ? "border-r" : ""
      } transition-all duration-300`}
    >
      <div className="flex flex-col items-center px-3 py-4 mb-2">
        {!collapsed && (
          <Link to="/" className="flex justify-center w-full">
            <img
              src="/images/logo.svg"
              alt="Logo"
              className="h-14 pt-2 object-cover cursor-pointer"
            />
          </Link>
        )}

        <button
          onClick={toggleSidebar}
          className={`${styles.switchButton} text-white w-full px-3 py-2 mt-8 rounded-xl flex items-center justify-center gap-2 transition-colors duration-300`}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? (
            <Menu size={20} />
          ) : (
            <>
              <X size={20} />
              <span className="text-sm">Collapse Sidebar</span>
            </>
          )}
        </button>
      </div>

      {/* Search Bar */}
      {/* {!collapsed && !hasLimitedMenu && (
        <div className="px-3 mb-4">
          <div
            className={`flex items-center bg-opacity-20 ${
              isMonitoring ? "bg-gray-200" : "bg-slate-800"
            } rounded-xl px-3 py-2`}
          >
            <Search size={16} className="text-gray-400" />
            <input
              type="text"
              placeholder="Search menu..."
              className="bg-transparent border-none focus:outline-none text-sm ml-2 w-full"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      )} */}

      {/* Menu Component */}
      <SidebarMenu
        collapsed={collapsed}
        searchTerm={searchTerm}
        user={user}
        styles={styles}
        isMonitoring={isMonitoring}
        hasLimitedMenu={hasLimitedMenu}
      />

      <div className={`border-t ${styles.borderColor} pt-2 px-2`}>
        <button
          onClick={handleLogout}
          className={`w-full flex items-center ${
            collapsed ? "justify-center" : ""
          } gap-3 px-3 py-2 text-red-400 rounded-xl text-sm ${
            styles.hoverItem
          }`}
          title="Logout"
        >
          <LogOut size={18} className="shrink-0" />
          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
